import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

interface NavItemProps {
  label: string;
  href?: string;
  onClick?: () => void;
  isActive?: boolean;
  showCheckbox?: boolean;
  checkboxActive?: boolean;
  isMobile?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({
  label,
  href,
  onClick,
  isActive = false,
  showCheckbox = false,
  checkboxActive = false,
  isMobile = false,
}) => {
  const baseStyles = `
    font-modernist font-bold text-[16px] leading-normal
    px-3 py-2 rounded-md hover:bg-gray-100 transition-colors
    ${isMobile ? "w-full text-left" : ""}
    ${isActive && !showCheckbox ? "bg-primary/10 text-primary" : "text-[#141414]"}
  `;

  const content = (
    <>
      {showCheckbox && (
        <div
          className={`w-4 h-4 border-2 rounded flex items-center justify-center mr-2 ${
            checkboxActive
              ? "bg-[#60416D] border-[#60416D]"
              : "border-[#2C2C2C]"
          }`}
        >
          {checkboxActive && <Check className="w-3 h-3 text-white" />}
        </div>
      )}
      <span>{label}</span>
    </>
  );

  if (href) {
    return (
      <Link to={href} className={`flex items-center ${baseStyles}`} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`flex items-center ${baseStyles}`}
    >
      {content}
    </button>
  );
};

export default NavItem;